export const FETCH_ALL = 'staticpages_List';

export const FETCH = 'staticpages_FindById';

export const CREATE = 'staticpages_CreateOne';

export const EDIT = 'staticpages_UpdateById';

export const DELETE = 'staticpages_RemoveManyByIds';
